import { render, staticRenderFns } from "./MultiChoose.vue?vue&type=template&id=4bf4c10b&scoped=true&"
import script from "./MultiChoose.vue?vue&type=script&lang=js&"
export * from "./MultiChoose.vue?vue&type=script&lang=js&"
import style0 from "./MultiChoose.vue?vue&type=style&index=0&id=4bf4c10b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4c10b",
  null
  
)

export default component.exports